// ===========================================
// ENVIRONMENT CONFIGURATION
// ===========================================

// ---------- PRODUCTION LIVE ----------
// export const API_URL = "https://srv547457.hstgr.cloud:4002";
// export const API_URL_UPLOADS = "https://srv547457.hstgr.cloud:3020";
// export const XGO_WEB_URL = 'https://srv547457.hstgr.cloud:3000';
// export const API_URL_STORE = "https://srv547457.hstgr.cloud:3009";
// export const XGO_TEXT_SMS_URL = "https://srv547457.hstgr.cloud:3003";

// ---------- PRODUCTION TEST ----------
export const API_URL = "https://srv547457.hstgr.cloud:4002";
export const API_URL_UPLOADS = "https://srv547457.hstgr.cloud:3020";
export const XGO_WEB_URL = 'http://10.37.13.32:3000';
export const API_URL_STORE = "https://srv547457.hstgr.cloud:3009";
export const XGO_TEXT_SMS_URL = "https://srv547457.hstgr.cloud:3003";

// ---------- LOCAL TEST (active 2026-09-15 for local testing — see KNOWN_ISSUES_AND_FIX_BACKLOG.md
// #77 — production hasn't received today's financial rename code fix yet, so hitting production
// from here would show $0.00 everywhere on the Financial Overview page. SWITCH BACK to
// "PRODUCTION LIVE" above once done testing locally.) ----------
// export const API_URL = "http://localhost:4002";
// export const API_URL_UPLOADS = "https://srv547457.hstgr.cloud:3020";
// export const XGO_WEB_URL = 'http://localhost:3000';
// export const API_URL_STORE = "http://localhost:3009";
// export const XGO_TEXT_SMS_URL = "https://srv547457.hstgr.cloud:3003";

// ===========================================
// SHARED CONFIGURATION
// ===========================================

// Google Maps API Configuration
export const GOOGLE_MAPS_API_KEY = "AIzaSyDZG_3GglukjKo0k6rd9ckpoxX6XCOElVo";

// Toast Configuration
export const TOAST_CONFIG = {
  position: "top-center",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "light",
};
